import { delay, TimeUtils } from '@colonist/utils';
import { UITopNotificationType } from '../notifications/UINotificationController.ts';
import { globalClientVariables, notificationController } from '../EntryShared.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { logError } from '../ui_utils/Utils.ts';
import { UIReconnectingBackgroundView } from './UIReconnectingBackgroundView.ts';
import { KeyBindController } from '../KeyBindController.ts';
export class UIReconnectionController {
    startReconnecting() {
        if (!this.isEnabled) return;
        if (this.isReconnecting) return;
        this.isReconnecting = true;
        notificationController === null || notificationController === void 0 ? void 0 : notificationController.removeDisconnectBanners();
        if (!this.hideConnect && !this.canReconnectFunction()) {
            this.displayReconnectBanner();
            this.disable();
            return;
        }
        const delayBeforeTellingUserToRefreshBrowser = 30 * TimeUtils.MILLISECONDS;
        clearTimeout(this.maxDisconnectTimeout);
        this.maxDisconnectTimeout = setTimeout(()=>{
            this.displayReconnectBanner();
        }, delayBeforeTellingUserToRefreshBrowser);
        this.timeDisconnected = Date.now();
        if (!this.hideConnect) UIReconnectingBackgroundView.show({
            key: 'strings:game.gameState.gameLogs.gameDisconnected.reconnecting'
        });
        this.hideConnect = false;
        void this.reconnect();
    }
    async reconnect() {
        const reconnectAttemptDelay = 3 * TimeUtils.MILLISECONDS;
        let attempt = 1;
        while(attempt <= UIReconnectionController.MAX_RECONNECT_ATTEMPTS){
            const reconnectResult = await this.reconnectFunction();
            switch(reconnectResult){
                case 'connected':
                    this.connectionReestablished();
                    return;
                case 'retry':
                    await delay(reconnectAttemptDelay);
                    attempt += 1;
                    break;
                case 'permanentlyFailed':
                    this.removeUI();
                    this.displayReconnectBanner();
                    this.isReconnecting = false;
                    return;
            }
        }
    }
    connectionReestablished() {
        this.isReconnecting = false;
        clearTimeout(this.maxDisconnectTimeout);
        KeyBindController.instance.clearAllKeyBinds();
        this.removeWarnings();
    }
    displayReconnectBanner() {
        const isNonBrowserEnvironment = UIUtilsEjsVariables.isUserOnDiscord || UIUtilsEjsVariables.isUserOnMobileAppOrWeb;
        const context = isNonBrowserEnvironment ? 'activity' : 'browser';
        const text = {
            key: 'strings:homePage.loadingError.prompt',
            options: {
                context: context
            }
        };
        if (UIUtilsEjsVariables.socketDebugActive) logError('connect', [
            text
        ]);
        if (globalClientVariables.serverUpdated) {
            const updateMessage = {
                key: 'strings:popups.errors.newVersion.newVersionReleasedWarningLostConnection'
            };
            notificationController === null || notificationController === void 0 ? void 0 : notificationController.show(updateMessage, UITopNotificationType.SocketError, updateMessage, undefined, undefined, false);
        } else {
            notificationController === null || notificationController === void 0 ? void 0 : notificationController.show(text, UITopNotificationType.SocketError, {
                key: 'strings:colonistCommon.buttons.reload'
            }, ()=>location.reload(), undefined, false);
        }
        clearTimeout(this.maxDisconnectTimeout);
    }
    removeWarnings() {
        var _this_timeDisconnected;
        const timeDisconnected = (_this_timeDisconnected = this.timeDisconnected) !== null && _this_timeDisconnected !== void 0 ? _this_timeDisconnected : Date.now();
        const minimumTimeToDisplayReconnectScreenForBetterUX = 1 * TimeUtils.MILLISECONDS;
        const elapsedTime = Date.now() - timeDisconnected;
        const remainingTime = minimumTimeToDisplayReconnectScreenForBetterUX - elapsedTime;
        setTimeout(()=>{
            this.removeUI();
        }, remainingTime);
        this.timeDisconnected = undefined;
    }
    // eslint-disable-next-line class-methods-use-this
    removeUI() {
        UIReconnectingBackgroundView.remove();
        notificationController === null || notificationController === void 0 ? void 0 : notificationController.removeSocketErrorBanners();
    }
    disable() {
        this.isEnabled = false;
    }
    constructor(reconnectFunction, canReconnectFunction, hideFirstConnect = false){
        this.isReconnecting = false;
        this.hideConnect = false;
        this.isEnabled = true;
        this.reconnectFunction = reconnectFunction;
        this.canReconnectFunction = canReconnectFunction;
        this.hideConnect = hideFirstConnect;
    }
}
UIReconnectionController.MAX_RECONNECT_ATTEMPTS = 15;
